module.exports = __webpack_public_path__ + "static/pattern-43d136b3a3a3dae576c63eeae7f398d3.svg";